export const commonPageEventActions = {
    searchSection: {
        searchBox: {
            SEARCH: 'click_search',
            CLICK_SEARCH: 'searchbox_click_search',
        },
    },
    breadcrumbSection: {
        BREADCRUMB: 'click_breadcrumb',
    },
    virtualTourTag: {
        VIRTUAL_TOUR_TAG_CLICKED: 'virtual_tour_tag_clicked',
    },
}

export const landingPageEventActions = {
    searchSection: {
        searchBox: {
            ARRIVAL_DATE: 'add_arrvial',
            DEPARTURE_DATE: 'add_departure',
            LOCATION: 'add_destination',
            PERSONS_COUNT: 'click_pers',
        },
    },
    headerSection: {
        RENTAL: 'click_rental',
        WISHLIST: 'click_wishlist',
    },
    newsLetterSection: {
        REGISTER: 'click_newsletter_subscription',
    },
    listingCardSection: {
        TOP_INSERAT: 'click_topinserat',
        WISHLIST_POP_UP: 'popupWishlist',
    },
    stickyFooter: {
        VIEW_ALL_RECOMMENDATION_CLICKED: 'view_all_recommendations_clicked',
    },
}

export const searchResultListingsPageEventActions = {
    listViewPageSpecific: {
        TO_BE_ADDED: 'to_be_added',
        CLICK_LIST_VIEW: 'click_list_view',
        CLICK_GRID_VIEW: 'click_grid_view',
    },
    mapViewPageSpecific: {
        mapSection: {
            MAP: 'do_mapaction',
        },
    },
    LISTINGS: 'click_resultlist_snippet',
    tileViewPageSpecific: {
        TO_BE_ADDED: 'to_be_added',
    },
    filterSection: {
        FILTER_CLICK: 'result_filter_click_filteroption',
    },
}

export const eventPageActions = {
    landingPageActions: {
        SEARCH_BUTTON: 'click_bk_search',
        MOST_POPULAR_DESTINATION: 'click_bk_mostpopular_by_dest',
        MOST_POPULAR_CATEGORY: 'click_bk_mostpopular',
    },
    searchResultPageActions: {
        SEARCH_RESULT_SNIPPET: 'click_bk_events_srl_snippet',
    },
    detailPageActions: {
        BOOKING_BUTTON: 'click_bk_events_booking',
    },
}

export const pdpPageActions = {
    ENQUIRY_BUTTON_CLICKED: 'enquiry_button_clicked',
    CALL_BUTTON_CLICKED: 'call_button_clicked',
    BOOK_NOW_BUTTON_CLICKED: 'book_now_button_clicked',
    BINDING_INQUIRY_BUTTON_CLICKED: 'binding_enquiry_button_clicked',
    CONTACT_ENTER_DETAILS_BUTTON_CLICKED: 'contact_details_button_clicked',
    PDP_PAGE_OPENED: 'pdp_page_opened',
    VIEW_ITEM: 'view_item',
    SELECT_ITEM: 'select_item',
    SHOW_MORE_REVIEWS_BUTTON_CLICKED: 'show_more_reviews_clicked',
    HIDE_REVIEWS_CLICKED: 'hide_reviews_clicked',
    GIVE_REVIEW_CLICKED: 'give_review_clicked',
    DATE_PICKER_START_DATE_CHANGED: 'date_picker_start_date_changed',
    DATE_PICKER_END_DATE_CHANGED: 'date_picker_end_date_changed',
    DATES_SELECTED: 'dates_selected',
    ADULTS_COUNT_CHANGED: 'adults_count_changed',
    CHILDREN_COUNT_CHANGED: 'children_count_changed',
    PETS_COUNT_CHANGED: 'pets_count_changed',
    CREATE_ENQUIRY_BUTTON_CLICKED: 'create_enquiry_button_clicked',
    ENQUIRY_FIELD_CLICKED: 'enquiry_field_clicked',
    ENQUIRY_POPUP_DATE_GUEST_TOGGLE_CLICKED: 'enquiry_popup_date_guest_toggle_clicked',
    ENQUIRY_POPUP_OPENED: 'enquiry_popup_opened',
    CHECK_AVAILABILITY_BUTTON_CLICKED: 'check_availability_button_clicked',
    COMBO_LISTING_POPUP_OPEBED: 'combo_listing_popup_opned',
    SHOW_MORE_ACCOMMODATIONS_CLICKED: 'show_more_accommodations_clicked',
    SELECTED_UNIT_CHANGE: 'selected_unit_changed',
    SELECT_DATES_BUTTON_CLICKED: 'select_dates_button_clicked_in_entity_section',
    GALLERY_MAIN_IMAGE_CLICKED: 'gallery_main_image_clicked',
    GALLERY_THUMBNAIL_CLICKED: 'gallery_thumbnail_clicked',
    GALLERY_VIEW_ALL_CLICKED: 'gallery_view_all_clicked',
    GALLERY_FULLSCREEN_IMAGE_CLICKED: 'gallery_fullscreen_image_clicked',
    GALLERY_FULLSCREEN_OPENED: 'gallery_fullscreen_opened',
    GALLERY_OVERLAY_OPENED: 'gallery_overlay_opened',
    GALLERY_VIRTUAL_TOUR_AVAILABLE: 'gallery_virtual_tour_available',
}

export const bulkInquiryPageActions = {
    // Lister page (SRL)
    TOGGLE_CLICKED_ON: 'bulk_inquiry_toggle_clicked_on',
    TOGGLE_CLICKED_OFF: 'bulk_inquiry_toggle_clicked_off',
    INFO_ICON_HOVERED: 'bulk_inquiry_info_icon_hovered',
    TOGGLE_TOOLTIP_DISMISSED: 'bulk_inquiry_toggle_tooltip_dismissed',
    LISTING_SELECTED: 'bulk_inquiry_listing_selected',
    LISTING_DESELECTED_FROM_CARD: 'bulk_inquiry_listing_deselected_from_card',
    // Tray
    COMPARE_CLICKED: 'bulk_inquiry_compare_clicked',
    SEND_INQUIRY_FROM_TRAY_CLICKED: 'bulk_inquiry_send_inquiry_from_tray_clicked',
    LISTING_DESELECTED_FROM_TRAY: 'bulk_inquiry_listing_deselected_from_tray',
    // Compare modal
    COMPARE_MODAL_CLOSED: 'bulk_inquiry_compare_modal_closed',
    LISTING_DESELECTED_FROM_COMPARE_MODAL: 'bulk_inquiry_listing_deselected_from_compare_modal',
    SEND_INQUIRY_FROM_COMPARE_MODAL_CLICKED: 'bulk_inquiry_send_inquiry_from_compare_modal_clicked',
    COMPARE_MODAL_IMAGE_CLICKED: 'bulk_inquiry_compare_modal_image_clicked',
    COMPARE_MODAL_CAROUSEL_INTERACTED: 'bulk_inquiry_compare_modal_carousel_interacted',
    COMPARE_MODAL_WISHLIST_CLICKED: 'bulk_inquiry_compare_modal_wishlist_clicked',
    ADD_MORE_AVATAR_CLICKED: 'bulk_inquiry_add_more_avatar_clicked',
    ADD_MORE_BROWSE_CLICKED: 'bulk_inquiry_add_more_browse_clicked',
    ADD_MORE_INTERACTED: 'bulk_inquiry_add_more_interacted',
    // Checkout page
    SALUTATION_CLICKED: 'bulk_inquiry_salutation_clicked',
    FORM_FIELD_CLICKED: 'bulk_inquiry_form_field_clicked',
    ADDRESS_TOGGLE_CLICKED: 'bulk_inquiry_address_toggle_clicked',
    SUBMIT_CLICKED: 'bulk_inquiry_submit_clicked',
    SWIFTCOVER_TOGGLE_CLICKED: 'bulk_inquiry_swiftcover_toggle_clicked',
    STAY_DETAILS_MODIFY_CLICKED: 'bulk_inquiry_stay_details_modify_clicked',
    STAY_DETAILS_DONE_CLICKED: 'bulk_inquiry_stay_details_done_clicked',
    ARRIVAL_FIELD_CLICKED: 'bulk_inquiry_arrival_field_clicked',
    DEPARTURE_FIELD_CLICKED: 'bulk_inquiry_departure_field_clicked',
    ARRIVAL_DATE_CHANGED: 'bulk_inquiry_arrival_date_changed',
    DEPARTURE_DATE_CHANGED: 'bulk_inquiry_departure_date_changed',
    HOSTS_LIST_TOGGLE_CLICKED: 'bulk_inquiry_hosts_list_toggle_clicked',
    GUESTS_FIELD_CLICKED: 'bulk_inquiry_guests_field_clicked',
    ADULTS_COUNT_CHANGED: 'bulk_inquiry_adults_count_changed',
    CHILDREN_COUNT_CHANGED: 'bulk_inquiry_children_count_changed',
    PETS_COUNT_CHANGED: 'bulk_inquiry_pets_count_changed',
    GUEST_PICKER_APPLY_CLICKED: 'bulk_inquiry_guest_picker_apply_clicked',
    // Cost breakup: mobile has no hover, so it tracks a tap instead; desktop tracks hover.
    COST_BREAKUP_CLICKED: 'bulk_inquiry_cost_breakup_clicked',
    COST_BREAKUP_HOVERED: 'bulk_inquiry_cost_breakup_hovered',
}

export const inquirySuccessPageEventActions = {
    SENT_BOOKING: 'sent_booking',
    CLICK_LIFE_TERRA: 'click_lifeterra',
    CLICK_CALL_HOST: 'click_call_host',
    CLICK_CHECK_NOW: 'click_check_now',
    CLICK_OBJECT_RECOMMENDATION: 'click_object_recommendation',
    CLOSE_LEAD_SHARING_POPUP: 'close_lead_sharing_popup',
    SEND_LEAD_INQUIRY: 'send_lead_inquiry',
    SEND_LEAD_INQUIRY_EMBEDDED: 'send_lead_inquiry_embedded',
    CLICK_OBJECT_RECOMMENDATION_EMBEDDED: 'click_object_recommendation_embedded',
}

export const topicLandingPageEventActions = {
    CLICK_TOPIC_CARD: 'click_holiday_regions_and_ideas_item',
}
